module.exports = __webpack_public_path__ + "static/img/MANUEL_MONROY.c35400a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/MANUEL_MONROY.jpg
// module id = 8sw3
// module chunks = 1